import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/splus-group-buying/Index.vue')
const Rewards = () => import('../activity/splus-group-buying/Rewards.vue')
const Landing = () => import('../activity/splus-group-buying/landing/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/splus-group-buying',
  name: 'activity_splus_group_buying',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '春日年卡拼团GO',
    expiryDate: '2024-04-22',
  },
}

export const rewardsRoute: RouteConfig = {
  path: '/activity/splus-group-buying/rewards',
  name: 'activity_splus_group_buying_rewards',
  component: Rewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的奖品',
    expiryDate: '2024-04-22',
  },
}

export const landingRoute: RouteConfig = {
  path: '/activity/splus-group-buying/landing',
  name: 'activity_splus_group_buying_landing',
  component: Landing,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'S+装扮特权上新',
  },
}

export default [indexRoute, rewardsRoute, landingRoute]
